import { slice } from './slice'

const uiActions = {
	...slice.actions,
}

export const { setDoctorExamPageActivePanel } = uiActions

export default uiActions
